export default __webpack_public_path__ + "static/media/Logo.5ce1de4e.svg";